import {UtilsService} from '../../../../shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from '../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {PorcentajeToleranciaNivelesPesoService} from '../../services/porcentaje-tolerancia-niveles-peso.service';

@Component({
  selector: 'app-porcentaje-tolerancia-niveles-peso',
  templateUrl: './porcentaje-tolerancia-niveles-peso.component.html',
  styleUrls: ['./porcentaje-tolerancia-niveles-peso.component.scss'],
})
export class PorcentajeToleranciaNivelesPesoComponent implements OnInit, AfterViewInit {
  public loading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.porcentajeToleranciaNivelesPeso;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public tituloModal: string;
  public isCreate: boolean = true;
  public valorFlete: any;
  public materialInvalido: boolean = true;

  public cmbNivel = [
    {
      id: 1,
      desca: 1
    },
    {
      id: 2,
      desca: 2
    },
    {
      id: 3,
      desca: 3
    },
  ]

  public formulario = new FormGroup({
    id: new FormControl('', []),
    mate: new FormControl('', [Validators.required]),
    desmat: new FormControl('', [Validators.required]),
    nivel: new FormControl('', [Validators.required]),
    acini: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,4})?$/)]),
    acifi: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,4})?$/)]),
    humini: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,4})?$/)]),
    humifi: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,4})?$/)]),
    pesini: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,4})?$/)]),
    pesfin: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,4})?$/)]),
    //mejora de ampliar a 100 caracteres
    auto: new FormControl('', [Validators.required, Validators.maxLength(100)]),
  });
  restriccion: any;
  restriccionData: any;

  constructor(
    private _util: UtilsService,
    private porcentajeToleranciaNivelesPesoService: PorcentajeToleranciaNivelesPesoService
  ) {
  }

  get materialControl() {
    return this.formulario.get('mate');
  }

  validateMaterial() {
    return true;
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Secuencial',
        field: 'id',
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: 'Material',
        field: 'mate',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'Descripción Material',
        field: 'desmat',
        sortable: true,
        filter: true,
        width: 300,
      },
      {
        headerName: 'Nivel',
        field: 'nivel',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Acidez Ini',
        field: 'acini',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Acidez Fin',
        field: 'acifi',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Hum+Imp Ini',
        field: 'humini',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Hum+Imp Fin',
        field: 'humifi',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Peso Ini',
        field: 'pesini',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Peso Fin',
        field: 'pesfin',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Autorización',
        field: 'auto',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 110,
        cellRendererParams: {
          onClick: this.editarValorFlete.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 80,
      //   cellRendererParams: {
      //     onClick: this.eliminarValorFlete.bind(this),
      //     label: this.DAT_BTNS.eliminar,
      //     colorBoton: this.DAT_BTNCSS.danger,
      //   }
      // },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {
    this.girdComponent();
  }

  ngAfterViewInit() {
    this.obtenerValores();
  }

  obtenerValores() {
    this.loading = true;
    this.porcentajeToleranciaNivelesPesoService.obtener().subscribe(
      (resp) => {
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
  }

  guardarEditarValorFlete() {
    this.loading = true;
    if (this.formulario.invalid) return;
    this.valorFlete = this.formulario.getRawValue();
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        // text: `${this.valorFlete.cod_origen}`,
        action: this.DAT_BTNS.editar,
        funcion: this.porcentajeToleranciaNivelesPesoService.actualizar(this.valorFlete),
      })
      .then(() => {
        this.obtenerValores();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarCrearNuevNuevoValorFlete() {
    this.loading = true;
    if (this.formulario.invalid) return;
    this.valorFlete = this.formulario.getRawValue();
    console.log("this.valorFlete", this.valorFlete)
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        // text: `Garita: ${this.valorFlete.cod_origen}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.porcentajeToleranciaNivelesPesoService.crear(this.valorFlete),
      })
      .then(() => {
        this.obtenerValores();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  nuevoRegistro() {
    this.isCreate = true;
    // this.formulario.updateValueAndValidity();
    this.formulario.reset();
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.openModal();
  }

  editarValorFlete({rowData}) {
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.formulario.patchValue(rowData);

    this.onChangeMaterial('');
    this.openModal();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNuevNuevoValorFlete();
    if (!this.isCreate) this.guardarEditarValorFlete();
  }

  openModal() {
    document.getElementById('abrirModalAgregarItem').click();
  }

  // onChangeMaterial() {
  //   this.porcentajeToleranciaNivelesPesoService.getMaterial(this.formulario.get('mate').value).subscribe(
  //     (resp) => {
  //       if (resp) {
  //         this.formulario.controls['desmat'].setValue(resp.descripcion);
  //       } else {
  //         this.formulario.controls['desmat'].setValue('');
  //       }
  //     },
  //     (error) => {
  //       this.formulario.controls['desmat'].setValue('');
  //     }
  //   );
  // }

  closeModal() {
    document.getElementById('cerrarModalAgregarGarita').click();
  }

  noWhitespace(event: KeyboardEvent) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32)
      return false;

    return true;
  }

  onChangeMaterial(event: any) {
    console.log("onChangeMaterial2", this.formulario.get('mate').value)
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;

    var element = document.getElementById("mate");
    element.classList.remove("is-valid");
    element.classList.remove("is-invalid");
    element.classList.add("is-invalid");

    this.porcentajeToleranciaNivelesPesoService.getMaterial(this.formulario.get('mate').value).subscribe(
      (resp) => {
        if (resp) {
          element.classList.remove("is-invalid");
          element.classList.add("is-valid");
          this.materialInvalido = false;
          this.formulario.controls['desmat'].setValue(resp.idMaterial + " - "+ resp.dscaMaterial);
        } else {
          this.materialInvalido = true;
          this.formulario.controls['desmat'].setValue('');
        }
        this.onChangeValues();
        this.loading = false;
      },
      (error) => {
        this.onChangeValues();
        this.loading = false;
        this.materialInvalido = true;
        this.formulario.controls['desmat'].setValue('');
      }
    );
  }

  eliminarValorFlete({rowData}) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.porcentajeToleranciaNivelesPesoService.borrar(rowData.id),
      })
      .then((res: any) => {
        this.obtenerValores();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  onChangeNivel() {

    var element = document.getElementById("nivel");
    element.classList.remove("is-valid");
    element.classList.remove("is-invalid");

    if (this.formulario.get('nivel').value.length > 0 && this.formulario.get('nivel').value.length != '')
      element.classList.add("is-valid");
    else
      element.classList.add("is-invalid");

  }

  onChangeValues() {
    console.log("onChangeValues");

    this.restriccion = false;

    if (this.formulario.get('mate').value == null) return;
    if (this.formulario.get('nivel').value == null) return;

    if (
      this.formulario.get('mate').value.length > 0 &&
      this.formulario.get('nivel').value.length > 0
    ) {

      this.valorFlete = this.formulario.getRawValue();

      for (let i = 0; i < this.rowData.length; i++) {
        if(this.rowData[i].id == this.formulario.get("id").value) continue;
        console.log("this.rowData[i].mate", this.rowData[i].mate, this.formulario.controls['mate'].value)
        console.log("this.rowData[i].nivel", this.rowData[i].nivel, this.formulario.get('nivel').value)
        if (
          this.rowData[i].mate == this.formulario.controls['mate'].value &&
          this.rowData[i].nivel == this.formulario.get('nivel').value
        ) {
          this.restriccion = true;
          this.restriccionData = this.rowData[i];
          break;
        }
      }
    }

  }

  validForm() {

    let invalid = [];
    let controls = this.formulario.controls;
    for (let name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log(invalid);

    console.log("materialInvalido", this.materialInvalido)
    console.log("formulario.invalid", this.formulario.invalid)
    console.log("restriccion", this.restriccion)
    console.log("restriccion", this.formulario)
    return (
      this.materialInvalido == false &&
      this.formulario.invalid == false &&
      this.restriccion == false) ? false : true;
  }

  keyDecimals(event: KeyboardEvent) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

}
